/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdminTemplateFileType } from '../models/AdminTemplateFileType';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AdminTemplateFileService {

    /**
     * Download CSV template file
     * @returns binary Success
     * @throws ApiError
     */
    public static adminDownloadTemplate({
        fileType,
    }: {
        /**
         * File Type
         */
        fileType: AdminTemplateFileType,
    }): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/templateFile/{fileType}',
            path: {
                'fileType': fileType,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
